var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width)?_c('input-with-unit',{attrs:{"alternative-units":['px', 'vw', '%'],"size":"small"},on:{"updated":_vm.set},model:{value:(_vm.width),callback:function ($$v) {_vm.width=$$v},expression:"width"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }